/**
 * @generated SignedSource<<16fbf52450e71c5a2d656c3109f57d90>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pricingRuleEditor_ProductNameQuery$variables = {
  id: string;
};
export type pricingRuleEditor_ProductNameQuery$data = {
  readonly node: {
    readonly name?: string;
  } | null;
};
export type pricingRuleEditor_ProductNameQuery = {
  response: pricingRuleEditor_ProductNameQuery$data;
  variables: pricingRuleEditor_ProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pricingRuleEditor_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pricingRuleEditor_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "063cc9fbc22f50942d1e8682972c5635",
    "id": null,
    "metadata": {},
    "name": "pricingRuleEditor_ProductNameQuery",
    "operationKind": "query",
    "text": "query pricingRuleEditor_ProductNameQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b3e92271329d64cf2cf66ed80a41a89";

export default node;
